<template>
	<Popup v-model="selfDisplay" :title="title" confirmBtnText="确认" @confirmClick="handleAddClick" :confirmBtnDisplay="type == 'add'">
		<div v-loading="loading" style="padding: 15px">
			<div class="base_form_row">
				<span class="b_label">
					<span style="color: #f00">*</span>
					联系电话：
				</span>
				<el-input v-model="phone" :disabled="disabled" maxlength="11" @change="phoneChange" placeholder="输入联系电话"></el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px">
				<span class="b_label">
					<span style="color: #f00">*</span>
					是否带框架
				</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="hasFrame" :disabled="disabled">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="2">否</el-radio>
					</el-radio-group>
				</div>
			</div>

			<div class="base_form_row" style="margin-top: 20px">
				<span class="b_label">收货地址</span>

				<el-input :value="addr" disabled placeholder="输入联系电话"></el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px">
				<span class="b_label">
					<span style="color: #f00">*</span>
					订单状态
				</span>
				<div class="b_checkbox_group">
					<el-select v-model="status" placeholder="请选择" style="width: 100%" :disabled="disabled">
						<el-option v-for="v in statusList" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
					<!-- <el-radio-group v-model="orderStatus">
						<el-radio v-for="v in appOrderStatusList" :key="v.id" :label="v.id">{{ v.name }}</el-radio>
					</el-radio-group> -->
				</div>
			</div>
			<template v-if="status >= 3">
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">
						<span style="color: #f00">*</span>
						快递公司：
					</span>
					<el-input v-model="kdCodeReturn" placeholder="请输入快递公司" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">
						<span style="color: #f00">*</span>
						快递单号：
					</span>
					<el-input v-model="orderNoReturn" placeholder="请输入快递单号" disabled></el-input>
				</div>
			</template>
			<div class="base_form_row" style="margin-top: 20px">
				<span class="b_label">
					<span style="color: #f00">*</span>
					检测类型
				</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="detection_type" :disabled="disabled"  @change="radioChange">
						<el-radio label="lvbo">镜片验配</el-radio>
						<!-- <el-radio label="lvbo2">双眼滤波评估</el-radio> -->
					</el-radio-group>
				</div>
			</div>
			<div class="base_form_row" style="margin-top: 20px">
				<span class="b_label">检测信息</span>
				<el-select v-model="detection" placeholder="请选择检测信息" style="width: 100%" :disabled="disabled" @change="detectionChange">
					<el-option v-for="v in detectionL" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			<div class="base_form_row" style="margin-top: 20px">
				<span class="b_label">
					<span style="color: #f00">*</span>
					上传图片
				</span>
				<div v-if="!post && !disabled" class="b_upload b_inline_block">
					<el-button type="primary">点击上传</el-button>
					<input type="file" accept="image/*" @change="handlePostUpload" />
					<span class="b_upload_tip">请上传jpg或者png图片！！！</span>
				</div>
				<div v-if="post" class="b_upload b_inline_block" style="border: 1px solid #ccc">
					<img :src="post" alt="" style="" />
					<i @click="handlePostDelete" v-if="type == 'add'"></i>
				</div>
			</div>
			<template v-if="testParam.OS">
				<div class="base_form_row" style="margin-top: 20px">
					<span class="b_label">检测参数</span>
				</div>
				<!-- OS 左眼裸!
OD 右眼裸
C OS 左眼矫
C OD 右眼矫
L SPH 左镜片球镜
L CYL 左镜片柱镜
L AX 左镜片轴位
R SPH 右镜片球镜R CYL 右镜片柱镜R AX 右镜片轴位
PD 瞳距 -->
				<div class="" style="padding-left: 40px">
					<div class="table">
						<div class="item">
							<span>OS左眼裸：</span>
							{{ testParam.OS || '--' }}
						</div>
						<div class="item">
							<span>OD 右眼裸：</span>
							{{ testParam.OD || '--' }}
						</div>
						<div class="item">
							<span>C_OS 左眼矫：</span>
							{{ testParam.C_OS || '--' }}
						</div>
						<div class="item">
							<span>C_OD 右眼矫：</span>
							{{ testParam.C_OD || '--' }}
						</div>
						<div class="item">
							<span>L_SPH 左镜片球镜：</span>
							{{ testParam.L_SPH || '--' }}
						</div>
						<div class="item">
							<span>L_CYL 左镜片柱镜：</span>
							{{ testParam.L_CYL || '--' }}
						</div>
						<div class="item">
							<span>L_AX 左镜片轴位：</span>
							{{ testParam.L_AX || '--' }}
						</div>
						<div class="item">
							<span>R_SPH 右镜片球镜：</span>
							{{ testParam.R_SPH || '--' }}
						</div>
						<div class="item">
							<span>R_CYL 右镜片柱镜：</span>
							{{ testParam.R_CYL || '--' }}
						</div>
						<div class="item">
							<span>R_AX 右镜片轴位：</span>
							{{ testParam.R_AX || '--' }}
						</div>
						<div class="item">
							<span>PD 瞳距：</span>
							{{ testParam.PD || '--' }}
						</div>
						<div class="item">
							<span>好眼眼别【L/R】：</span>
							{{ testParam.BETTER_EYE || '--' }}
						</div>
					</div>
				</div>
			</template>
		</div>
	</Popup>
</template>

<script>
import { mapState } from 'vuex';
import Api from '../../../../../api/index.js';
import BaseMethods from '../../../../../assets/js/base.js';
export default {
	model: {
		prop: 'display',
		event: 'changeDisplay'
	},
	props: {
		display: Boolean,
		type: {
			type: String,
			default: 'view'
		},
		obj: {
			type: Object,
			default() {
				return {};
			}
		}
	},

	mounted() {
		this.clipboardInstance = null;
		this.display && (this.selfDisplay = true);
	},
	data() {
		return {
			disabled: true,
			loading: false,
			selfDisplay: false,

			number: '',
			serial: '',
			price: '',
			amount: '',
			num: '',
			addr: '',
			shopName: '',
			uCode: '',
			date: '',
			sendStatus: '',
			orderStatus: 1,
			refundReason: '',
			refundRemark: '',
			// "orderStatus": 1 //1-已下单 2-制作中 3-已发货 4-已收货

			// -----------------
			status: 1,
			statusList: [
				{
					id: 1,
					name: '未发货'
				},
				{
					id: 2,
					name: '制作中'
				},
				{
					id: 3,
					name: '已发货'
				},
				{
					id: 4,
					name: '已收货'
				}
			],
			phone: '',
			hasFrame: 1,
			// 检测信息
			detection: 0,
			detectionL: [],
			radio: 1,
			post: '',
			testParam: {},
			testResult: {},
			detectionData: {},
			address: {},
			kdCodeReturn: '',
			orderNoReturn: '',
			detection_type:'lvbo'
		};
	},
	computed: {
		...mapState(['appSendStatus', 'appOrderStatus']),
		title() {
			return this.type === 'add' ? '添加' : '查看';
		}
	},

	methods: {
		//信息查询
		detectionChange(e) {
			this.detection = 0;
			const foundItem = this.detectionL.find((item) => item.id == e);
			this.detectionData = foundItem;
			this.testParam = JSON.parse(foundItem.testParam);
			this.testResult = JSON.parse(foundItem.testResult);
			this.detection = e;
		},
		radioChange(){
			this.detection=''
			this.phoneChange(this.phone)
		},
		// 查找用户信息
		phoneChange(e) {
			console.log(e);
			if(!e){
				return
			}
			this.phone = e;
			Api.reportListAdmin({
				userPhone: e,
				type:this.detection_type
			})
				.then((res) => {
					console.log(res);
					if (res.data.success) {
						let data = res.data.data;
						if (data.length > 0) {
							this.detectionL = data.map((item) => {
								return {
									...item,
									id: item.id,
									name: `检查时间 ${item.createTs}`,
									testParam: item.testParam,
									testResult: item.testResult
								};
							});

							Api.getAdss(data[0].uflyId).then((rs) => {
								console.log(rs.data);
								if (rs.data.success) {
									this.address = rs.data.data[0];
									this.addr = `${this.address.detailedAddress}-${this.address.shippingAddress}`;
								}
							});
						} else {
							this.detectionL = [];
						}
					}
				})
				.then(() => {
					if (this.detection) {
						this.detectionChange(this.detection);
					}
				});
		},
		// 上传图片
		handlePostUpload(e) {
			const that = this;
			BaseMethods.uploadMultiImg(
				e,
				(base64, imgs_type, imgs_name) => {
					that.uploadPost(base64[0], imgs_type[0], imgs_name[0]);
				},
				(msg) => {
					that.$message.error(msg);
				}
			);
		},
		// 删除上传的图片
		handlePostDelete() {
			this.post = '';
		},
		// 上传图片
		uploadPost(base64, img_type, fileName) {
			const that = this;
			that.loading = true;
			let postName = `${new Date().getTime()}_${fileName}`;
			let requestData = {
				base: base64,
				picName: postName,
				type: 'uGateWayUrl'
			};
			Api.uploadPic(requestData).then(
				(res) => {
					if (res.data.success) {
						that.loading = false;
						that.post = res.data.data.imgUrl.split('?')[0];
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},

		// 点击复制
		copySerial() {},
		// 点击add
		handleAddClick() {
			if (this.type == 'add') {
				const that = this;
				that.loading = true;
				let requestData = {
					orderPhone: this.phone,
					kdCode: 'sf',
					testId: this.detectionData.id,
					testCreateTs: this.detectionData.createTs,
					customerId: this.detectionData.uflyId,
					deliveryId: this.address.id, //地址ID
					orderImg: this.post,
					orderStatus: this.status,
					orderNoReturn: this.orderNoReturn,
					kdCodeReturn: this.kdCodeReturn,
					type:this.detection_type
				};
				console.log(requestData);
				console.log(Api);
				Api.lensOrderSave(requestData).then(
					(res) => {
						if (res.data.success) {
							that.loading = false;
							that.$message.success(res.data.message);
							that.selfDisplay = false;
							that.$emit('onSuccess');
						} else {
							that.loading = false;
							that.$message.error(res.data.message);
						}
					},
					(e) => {
						that.loading = false;
						that.$message.error(e.message);
					}
				);
			}
		},
		// 选择训练时间
		handleDateChange() {
			if (this.date) {
				var destTime = new Date(this.date).getTime(),
					nowTime = new Date().getTime();
				if (destTime > nowTime) {
					this.$message.warning('下单时间不能超过当天');
					this.add_date = '';
				} else {
					this.getWithTrainingInfoByDate('add');
				}
			}
		}
	},
	watch: {
		// type(newVal) {
		// 	if (newVal == 'view') {
		// 		this.disabled = true;
		// 	} else {
		// 		this.disabled = false;
		// 	}
		// },
		display(newVal) {
			this.selfDisplay = newVal;
		},
		selfDisplay(newVal) {
			const that = this;
			that.$emit('changeDisplay', newVal);
			if (newVal) {
				console.log(that.obj);
				that.loading = false;
				that.number = that.obj.number;
				that.serial = that.obj.serial;
				that.price = that.obj.price;
				that.amount = that.obj.amount;
				that.num = that.obj.num;
				that.addr = that.obj.addr;
				that.shopName = that.obj.shopName;
				that.uCode = that.obj.uCode;
				that.date = that.obj.time;
				that.sendStatus = that.obj.sendValue;
				that.orderStatus = that.obj.orderStatusValue;
				that.refundReason = '';
				that.refundRemark = '';
				that.clipboardInstance = new that.Clipboard('.clipboard');
				// -------------
				that.detectionL = [];
				that.kdCodeReturn = that.obj.kdCodeReturn;
				that.orderNoReturn = that.obj.orderNoReturn;
				that.phone = that.obj.orderPhone;
				that.post = that.obj.orderImg;
				that.status = Number(that.obj.orderStatus) || '';
				that.testParam = {};
				that.testResult = {};
				that.detection = Number(that.obj.testId) || '';
				that.detection_type = that.obj.type||'lvbo';
				// that.clipboardInstance.on('success', () => {
				// 	that.$message.success('复制成功');
				// });
				if (this.obj.orderPhone) {
					this.phoneChange(this.obj.orderPhone);
				}
			} else {
				that.clipboardInstance && that.clipboardInstance.destroy();
			}
		}
	}
};
</script>

<style scoped>
.table {
	display: flex;
	flex-wrap: wrap;
	border: 1px solid #cccccc;
	border-top: 2px solid #cccccc;
	border-left: 2px solid #cccccc;
}
.item {
	width: 25%;
	border-bottom: 1px solid #cccccc;
	border-right: 1px solid #cccccc;
	padding: 4px;
	padding-left: 10px;
	color: #606266;
}
.item:nth-child(5n) {
	/* border-right: none; */
}

.item:nth-last-child(-n + 5) {
	/* border-bottom: none; */
}
</style>
